import React from "react";
import { Checkbox } from "semantic-ui-react";

interface ToggleOptionProps {
  checked: boolean;
  description: string;
  label: string;
  onToggle: () => void;
}

const ToggleOption: React.FC<ToggleOptionProps> = ({
  checked,
  description,
  label,
  onToggle,
}) => (
  <div className="set-toggle-row">
    <div className="set-toggle-tx">
      <div className="tl">{label}</div>
      <div className="ts">{description}</div>
    </div>
    <Checkbox
      toggle
      className="set-toggle-checkbox"
      checked={checked}
      aria-label={label}
      onChange={onToggle}
    />
  </div>
);

// Only the emails the site itself sends live here. The newsletter (Weekend
// Reads / Weekday Wisdom) is run from Mailchimp, whose own unsubscribe link
// is the real control; a toggle here never reached Mailchimp and only
// promised something it could not do.
const EmailOptions = ({
  weeklyLearningDigestEnabled,
  blogUpdatesEnabled,
  communityAlertsEnabled,
  handleWeeklyLearningDigestToggle,
  handleBlogUpdatesToggle,
  handleCommunityAlertsToggle,
}) => (
  <section className="set-block">
    <div className="set-block-title">
      <svg aria-hidden="true">
        <use href="#icon-mail" />
      </svg>
      Email options
    </div>

    <ToggleOption
      label="Weekly Learning digest"
      description="A Sunday recap of what you learned, XP earned, and your place on the leaderboard."
      checked={weeklyLearningDigestEnabled}
      onToggle={handleWeeklyLearningDigestToggle}
    />
    <ToggleOption
      label="New blog posts"
      description="One email when a new post goes up on the blog. Nothing else."
      checked={blogUpdatesEnabled}
      onToggle={handleBlogUpdatesToggle}
    />
    <ToggleOption
      label="Community alerts"
      description="When people reply to or mention you."
      checked={communityAlertsEnabled}
      onToggle={handleCommunityAlertsToggle}
    />
  </section>
);

export default EmailOptions;
